/**
 * @flow
 * @relayHash e9aa43fa274511386a6c011affdb3f99
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ShopDetailsPageQueryVariables = {|
  vendorID: string
|};
export type ShopDetailsPageQueryResponse = {|
  +shop: ?{|
    +ref_id: string,
    +id: string,
    +active: ?boolean,
  |}
|};
export type ShopDetailsPageQuery = {|
  variables: ShopDetailsPageQueryVariables,
  response: ShopDetailsPageQueryResponse,
|};
*/


/*
query ShopDetailsPageQuery(
  $vendorID: ID!
) {
  shop(id: $vendorID) {
    ref_id
    id
    active
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "vendorID",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "shop",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "vendorID",
        "type": "ID!"
      }
    ],
    "concreteType": "Shop",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "ref_id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "active",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ShopDetailsPageQuery",
  "id": null,
  "text": "query ShopDetailsPageQuery(\n  $vendorID: ID!\n) {\n  shop(id: $vendorID) {\n    ref_id\n    id\n    active\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShopDetailsPageQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "ShopDetailsPageQuery",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4dd2a8f31b6b9f5a40e10aff781e93f6';
module.exports = node;
